<template>
  <div class="discoupon_modal_box">
    <b-modal
      ref="modal"
      :id="modalId"
      hide-footer
      centered
      title="折價券折抵"
      modal-class="discount-modal"
      @hide="handleCleanTemp"
    >
      <Content
        @handleHide="hide"
        :product="product"
        :bonusData="bonusData"
        :index="index"
        :ticketNo.sync="ticketNo"
        @ticketNo="setticketNo"
        :enjoy-num-modal.sync="enjoyNum"
        :bonus-num-modal.sync="bonusNum"
        :bonusDescription="bonusDescription"
      />
    </b-modal>
  </div>
</template>

<script>
import Content from './Content';
import { mapMutations, mapGetters } from 'vuex';

export default {
  components: {
    Content
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    bonusData: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    ticketNo: {
      type: String,
      required: false
    },
    bonusDescription:{
      type:String,
      required:true
    }
  },

  data() {
    return {
      enjoyNum: '',
      bonusNum: null
    };
  },
  created() {
    this.bonusNum = this.bonusNumFromVuex;
    this.enjoyNum = this.enjoyNumFromVuex;
    if (this.bonusNumFromVuex == 0) {
      this.bonusNum = '';
    }
  },
  methods: {
    ...mapMutations('cart', ['setCartProductsDiscount']),
    hide() {
      this.$refs.modal.hide();
    },
    setticketNo(value) {
      this.$emit('update:ticketNo', value);
    },
    handleCleanTemp() {
      this.setCartProductsDiscount({
        index: this.index,
        couponDisTemp: '',
        ticketNoTemp: ''
      });
    }
  },
  computed: {
    ...mapGetters('cart', ['products']),
    modalId() {
      return 'discoupon_modal' + this.index;
    },
    bonusNumFromVuex() {
      return this.products[this.index].bonusDefaultNum;
    },

    enjoyNumFromVuex() {
      return this.products[this.index].enjoyDefaultNum;
    }
  }
};
</script>
